import React from "react";
import styles from "../stylesER.module.scss";

export const AgencyCommissionModal = ({
  isOpen,
  monthIndex,
  mesesCompletos,
  comisiones,
  comisionesBroker = [],
  costosProgramaticos = [],
  apx = [],
  oportunidades,
  formatCurrency,
  pais,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  // Contratos traen c.cliente directo; PAUTA lo resuelve por facturanumero en oportunidades.
  const clienteDeFactura = (c) =>
    c.cliente || oportunidades.find((o) => o.facturanumero === c.facturanumero)?.cliente || "—";

  const locale = pais === "Chile" ? "es-CL" : "es-PE";
  const importeCell = (c) =>
    c.moneda_dolar
      ? `US$ ${(c.importeOriginalMoneda || 0).toLocaleString(locale, { maximumFractionDigits: 0 })}`
      : formatCurrency(c.importe);

  // Total combinado = el que "manda" y coincide con la línea del ER
  const totalAgencia = comisiones.reduce((s, c) => s + c.comision, 0);
  const totalBroker = comisionesBroker.reduce((s, c) => s + c.comisionBroker, 0);
  const totalProgramatico = costosProgramaticos.reduce((s, c) => s + (c.takeLocal || 0), 0);
  const totalApx = apx.reduce((s, c) => s + (c.apxLocal || 0), 0);
  const totalCombinado = totalAgencia + totalBroker + totalProgramatico + totalApx;
  const hayEntries =
    comisiones.length > 0 || comisionesBroker.length > 0 || costosProgramaticos.length > 0 || apx.length > 0;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Costo intermediación - {mesesCompletos[monthIndex]}</h3>

        {/* ── Sección Agencia (tabla existente, intacta) ── */}
        <h4 className={styles.modalSeccionTitulo}>Agencia</h4>
        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th className={styles.agencyFacturaHeader}>Factura</th>
              <th className={styles.agencyClienteHeader}>Cliente</th>
              <th className={styles.agencyIntermediarioHeader}>Intermediario</th>
              <th className={styles.agencyImporteHeader}>Importe</th>
              <th className={styles.agencyPorcentajeHeader}>%</th>
              <th className={styles.agencyComisionHeader}>Comisión</th>
            </tr>
          </thead>
          <tbody>
            {comisiones.map((c, i) => (
              <tr key={i}>
                <td className={styles.agencyFacturaData}>{c.facturanumero}</td>
                <td className={styles.agencyClienteData}>{clienteDeFactura(c)}</td>
                <td className={styles.agencyIntermediarioData}>{c.intermediario}</td>
                <td className={styles.agencyImporteData}>{importeCell(c)}</td>
                <td className={styles.agencyPorcentajeData}>{c.porcentaje}%</td>
                <td className={styles.agencyComisionData}>{formatCurrency(c.comision)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ── Sección Broker (solo si hay entries) ── */}
        {comisionesBroker.length > 0 && (
          <>
            <h4 className={styles.modalSeccionTitulo}>Broker</h4>
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.agencyFacturaHeader}>Factura</th>
                  <th className={styles.agencyClienteHeader}>Cliente</th>
                  <th className={styles.agencyIntermediarioHeader}>Broker</th>
                  <th className={styles.agencyImporteHeader}>Importe</th>
                  <th className={styles.agencyPorcentajeHeader}>%</th>
                  <th className={styles.agencyComisionHeader}>Comisión</th>
                </tr>
              </thead>
              <tbody>
                {comisionesBroker.map((c, i) => (
                  <tr key={i}>
                    <td className={styles.agencyFacturaData}>{c.facturanumero}</td>
                    <td className={styles.agencyClienteData}>{clienteDeFactura(c)}</td>
                    <td className={styles.agencyIntermediarioData}>{c.brokerNombre}</td>
                    <td className={styles.agencyImporteData}>{importeCell(c)}</td>
                    <td className={styles.agencyPorcentajeData}>{c.porcentajeBroker}%</td>
                    <td className={styles.agencyComisionData}>{formatCurrency(c.comisionBroker)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* ── Sección Programática (take del exchange — solo si hay entries) ── */}
        {costosProgramaticos.length > 0 && (
          <>
            <h4 className={styles.modalSeccionTitulo}>Programática</h4>
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.agencyFacturaHeader}>Factura</th>
                  <th className={styles.agencyClienteHeader}>Cliente</th>
                  <th className={styles.agencyIntermediarioHeader}>Exchange</th>
                  <th className={styles.agencyImporteHeader}>Importe</th>
                  <th className={styles.agencyPorcentajeHeader}>%</th>
                  <th className={styles.agencyComisionHeader}>Take</th>
                </tr>
              </thead>
              <tbody>
                {costosProgramaticos.map((c, i) => (
                  <tr key={i}>
                    <td className={styles.agencyFacturaData}>{c.facturanumero}</td>
                    <td className={styles.agencyClienteData}>{clienteDeFactura(c)}</td>
                    <td className={styles.agencyIntermediarioData}>Place Exchange</td>
                    <td className={styles.agencyImporteData}>{importeCell(c)}</td>
                    <td className={styles.agencyPorcentajeData}>
                      {c.importe > 0 ? `${((c.takeLocal / c.importe) * 100).toFixed(1)}%` : "—"}
                    </td>
                    <td className={styles.agencyComisionData}>{formatCurrency(c.takeLocal)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* ── Sección APX (Publicis — solo si hay entries) ── */}
        {apx.length > 0 && (
          <>
            <h4 className={styles.modalSeccionTitulo}>APX (Publicis)</h4>
            <table className={styles.modalTable}>
              <thead>
                <tr>
                  <th className={styles.agencyFacturaHeader}>Factura</th>
                  <th className={styles.agencyClienteHeader}>Cliente</th>
                  <th className={styles.agencyIntermediarioHeader}>Acuerdo</th>
                  <th className={styles.agencyImporteHeader}>Importe</th>
                  <th className={styles.agencyPorcentajeHeader}>%</th>
                  <th className={styles.agencyComisionHeader}>APX</th>
                </tr>
              </thead>
              <tbody>
                {apx.map((c, i) => (
                  <tr key={i}>
                    <td className={styles.agencyFacturaData}>{c.facturanumero}</td>
                    <td className={styles.agencyClienteData}>{clienteDeFactura(c)}</td>
                    <td className={styles.agencyIntermediarioData}>APX</td>
                    <td className={styles.agencyImporteData}>{importeCell(c)}</td>
                    <td className={styles.agencyPorcentajeData}>{c.porcentaje}%</td>
                    <td className={styles.agencyComisionData}>{formatCurrency(c.apxLocal)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* ── Total combinado (agencia + broker + programática + apx) ── */}
        {hayEntries && (
          <table className={styles.modalTable}>
            <tbody>
              <tr className={styles.modalTotal}>
                <td colSpan="5">
                  <strong>Total intermediación</strong>
                </td>
                <td className={styles.agencyComisionData}>
                  <strong>{formatCurrency(totalCombinado)}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        )}

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
